import {BaseContainerModel} from "../../base-container.model";
import {
  bl_wf_issue_worklog_hdr_RowInterface,
  bl_wf_issue_worklog_hdr_RowClass,
  bl_wf_issue_worklog_ext_RowClass
} from "../../../dbschema";

export class WfIssueWorklogContainerModel extends BaseContainerModel {
  bl_wf_issue_worklog_hdr: bl_wf_issue_worklog_hdr_RowInterface = new bl_wf_issue_worklog_hdr_RowClass();
  bl_wf_issue_worklog_exts: bl_wf_issue_worklog_ext_RowClass[] = [];
}
